export default __webpack_public_path__ + "static/media/wShoes_2_p1.af116cf3.jpeg";